<template>
  <div class="gallery-modal">
    <div class="container">
      <div class="row">
        <div class="col-1 hidden-sm"/>
        <div class="col-10">
          <button @click="hideModal" class="close-modal" aria-label="Close modal">
            <svg class="ico ico--20">
              <use xlink:href="#icon-arrow-left"/>
            </svg>
          </button>
          <div class="slide-number">
            <span>{{ images.length }} image{{images.length > 1 && 's'}}</span>
          </div>          <div class="gallery-modal-cont">
          <button v-for="(image, index) in images"
                  class="image-cont"
                  :id="index+'-modal-image'"
                  :class="{ fullWidth: (index+1) % 3 === 0}"
                  @click="toggleSingleGalleryModal(index)"
                  aria-label="Open gallery modal">
            <img :src="image.hero" :alt="image.cap"/>
          </button>
        </div>
        </div>
      </div>
    </div>
    <button class="overlay" @click="hideModal" aria-label="Hide modal"/>
    <div v-if="isSingleModalVisible">
      <SingleModal :images="images"
                   :slideIndex="slideIndex"
                   :activeSlide="activeSlide"
                   :isSingleModalVisible="isSingleModalVisible"
                   @toggleSingleGalleryModal="toggleSingleGalleryModal"
      />
    </div>
  </div>
</template>

<script>
import SingleModal from "./single_gallery_modal";
export default {
  data: function () {
    return {
      isSingleModalVisible: false,
      slideIndex: null,
    }
  },
  props: {
    images: Array,
    activeSlide: Number,
    isModalVisible: Boolean,
  },
  components: {SingleModal},
  methods: {
    hideModal(){
      this.$emit('toggleModal');
    },
    toggleSingleGalleryModal(index) {
      this.isSingleModalVisible = !this.isSingleModalVisible;
      this.slideIndex = index;
      this.$emit('sendTrack', "click-open-single-modal-gallery", true)
    },
    keyDownHandler(e) {
      if (this.isModalVisible && e.keyCode === 27) {
        if (this.isSingleModalVisible) {
          this.isSingleModalVisible = !this.isSingleModalVisible;
        } else {
          this.$emit('toggleModal');
        }
      }
    }
  },
  mounted: function() {
    document.addEventListener('keydown', this.keyDownHandler);

    const element = document.getElementById(this.activeSlide+'-modal-image');

    if (element) {
      element.scrollIntoView({behavior: "smooth", block: "center", inline: "center"});
    }
  }
}
</script>

<style lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.gallery-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 16;
  width: 100%;
  height: 100%;
  overflow: scroll;
  background: $col_white;

  .row {
    .col-10 {
      margin: 0;
      width: 100%;
      position: relative;

      @media #{$desktop} {
        margin: 0 2%;
        width: 79.3333333333%;
      }
    }
  }

  .close-modal {
    top: 1rem;
    left: 1rem;
    z-index: 14;
    position: fixed;
    cursor: pointer;
    height: 2rem;
    width: 2rem;
    border-radius: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background: hsla(0,0%,100%,.7);
    transition: .3s;

    svg {
      width: 1.25rem;
      height: 1.25rem;
    }

    &:hover {
      transition: .3s;
      background: #efefef;
    }
  }

  .slide-number {
    position: absolute;
    top: 1.375rem;
    z-index: 3;
    left: calc(50% - 4.875rem / 2);
  }

  .gallery-modal-cont {
    z-index: 10;
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 4rem 0 .625rem;
    grid-row-gap: .625rem;
    grid-column-gap: .625rem;
  }

  .image-cont {
    height: 50vw;
    outline: none;
    width: calc(50% - .3125rem);

    img {
      width: 100%;
      height: 100%;
      cursor: pointer;
      object-fit: cover;
      transition: .3s;

      &:hover {
        -webkit-filter: brightness(80%);
        -webkit-transition: all .3s ease;
        -moz-transition: all .3s ease;
        -o-transition: all .3s ease;
        -ms-transition: all .3s ease;
        transition: all .3s ease;
      }
    }

    &.fullWidth {
      width: 100%;
    }
  }

  .overlay {
    background: transparent;
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }

  @media #{$desktop} {
    .close-modal {
      top: 1.5rem;
      left: 1.5rem;
    }

    .slide-number {
      top: 1.875rem;
    }

    .gallery-modal-cont {
      margin: 5rem 0;
      grid-row-gap: 1.25rem;
      grid-column-gap: 1.25rem;
    }

    .image-cont {
      width: calc(50% - .625rem);
      height: 28.125rem;

      img {
        border-radius: .25rem
      }
    }
  }
}
</style>